import { AxiosResponse } from "axios";
import { IGetRegistroOcorrenciaParams, IPageRegistroOcorrenciaDTO, IRegistroOcorrenciaDTO, IRegistroOcorrenciaForm } from "../../types/registroOcorrencia";
import { removeEmpty } from "../../utils/removeEmpty";
import { ApiBrave } from "../../Apis/Brave";

const basePath = "/registro-ocorrencia";

export class RegistroOcorrencia {
    static async listar(props: IGetRegistroOcorrenciaParams) : Promise<AxiosResponse<IPageRegistroOcorrenciaDTO>> {
        let params = new URLSearchParams(removeEmpty(props)).toString();
        return ApiBrave.get(`${basePath}?${params}`);
    }

    static async criar({uuid} : {uuid: string}) : Promise<AxiosResponse<IRegistroOcorrenciaDTO>> {
        return ApiBrave.post(`${basePath}?uuidAgendamento=${uuid}`);
    }

    static async atualizar({uuid, props} : {uuid: string, props: IRegistroOcorrenciaForm}) : Promise<AxiosResponse<IRegistroOcorrenciaDTO>> {
        return ApiBrave.put(`${basePath}/${uuid}`, props);
    }

    static async vincularArquivo({uuid, file} : {uuid: string, file: File}) : Promise<AxiosResponse<IRegistroOcorrenciaDTO>> {
        const formData = new FormData();
        formData.append("file", file);

        return ApiBrave.post(`${basePath}/${uuid}/anexar-arquivo`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        });
    }

    static async desvincularArquivo({uuid, uuidArquivo} : {uuid: string, uuidArquivo: string}) : Promise<AxiosResponse<IRegistroOcorrenciaDTO>> {
        return ApiBrave.delete(`${basePath}/${uuid}/desvincular-arquivo/${uuidArquivo}`);
    }

    static async comunicarAtraso(props: IRegistroOcorrenciaForm) : Promise<AxiosResponse<IRegistroOcorrenciaDTO>> {
        return ApiBrave.post(`${basePath}/comunicar-atraso`, props);
    }

}